module.exports = __webpack_public_path__ + "media/images/icons/outlined/vertical-align-top-4c82f4bcfd4ac6f9eff1c140f87fb54e.svg";